import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";

import FacilityOperations from './pages/facility-operations';
import Login from './pages/login';
import TrackerRegistration from './pages/tracker-registration';
import OrganizationalHierarchy from './pages/organizational-hierarchy';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import DPATHeader from './components/DPATHeader'
import AutomatedReportGenerationSystem from './pages/automated-report-generation-system';
import RequireAuth from "components/RequireAuth";
import { LocationProvider } from "context/LocationContext";
import ContextShell from "components/context-navigation/ContextShell";
import ContextModuleRenderer from "components/context-navigation/ContextModuleRenderer";
import SetupShell from "components/setup/SetupShell";
import SetupModulePage from "pages/setup/SetupModulePage";

const MainLayout = ({ children }) => {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex-1 ml-64 flex flex-col">
        <Header />
        <main className="flex-1 overflow-auto bg-gray-50">
          {children}
        </main>
      </div>
    </div>
  );
};

// const MainLayout2 = ({ children }) => {
//   return (
//     <div className="flex h-screen overflow-hidden">
//       <Sidebar />
//        <div className="flex-1 ml-64 flex flex-col">
//         <DPATHeader/>
//         <main className="flex-1 overflow-auto bg-gray-50">
//           {children}
//         </main>
//       </div>

//     </div>
//   );
// };

const MainLayout2 = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = React.useState("");
  const [timePeriod, setTimePeriod] = React.useState("annual-action-plan");

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <div className="flex-1 ml-64 flex flex-col">
        <DPATHeader
          selectedLocation={selectedLocation}
          setSelectedLocation={setSelectedLocation}
          timePeriod={timePeriod}
          setTimePeriod={setTimePeriod}
        />

        <main className="flex-1 overflow-auto bg-gray-50">
          {React.cloneElement(children, {
            selectedLocation,
            timePeriod
          })}
        </main>
      </div>
    </div>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <LocationProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Login route without sidebar */}
            <Route path="/login" element={<Login />} />

            {/* Default entry into context-first navigation */}
            <Route path="/" element={<Navigate to="/ghana/dashboard" replace />} />

            {/* private routes */}
            <Route element={<RequireAuth />} >
              {/* Context-first geographic + functional navigation */}
              <Route path="/ghana" element={<ContextShell />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path=":module" element={<ContextModuleRenderer />} />
                <Route path=":regionSlug/:module" element={<ContextModuleRenderer />} />
                <Route path=":regionSlug/:districtSlug/:module" element={<ContextModuleRenderer />} />
                <Route path=":regionSlug/:districtSlug/:subdistrictSlug/:module" element={<ContextModuleRenderer />} />
              </Route>

              <Route path="/setup" element={<SetupShell />}>
                <Route index element={<Navigate to="rcc-indicator-setup" replace />} />
                <Route path=":setupModule" element={<SetupModulePage />} />
              </Route>

              {/* Legacy dashboard routes now redirect into the context-first flow */}
              <Route path="/dashboard" element={<Navigate to="/ghana/dashboard" replace />} />
              <Route path="/national-dashboard" element={<Navigate to="/ghana/dashboard" replace />} />
              <Route path="/regional-dashboard" element={<Navigate to="/ghana/dashboard" replace />} />
              <Route path="/district-dashboard" element={<Navigate to="/ghana/dashboard" replace />} />

              {/* Other routes with sidebar and header (legacy / supplemental) */}
              <Route path="/tracker-registration" element={<MainLayout><TrackerRegistration /></MainLayout>} />
              <Route path="/organizational-hierarchy" element={<Navigate to="/ghana/rcc" replace />} />
              <Route path="/program-performance" element={<Navigate to="/ghana/reports" replace />} />
              <Route path="/facility-operations" element={<MainLayout><FacilityOperations /></MainLayout>} />
              <Route path="/meetings-management" element={<Navigate to="/ghana/trackers" replace />} />
              <Route path="/meeting-information-dashboard" element={<Navigate to="/ghana/trackers" replace />} />
              <Route path="/bulk-meeting-operations" element={<Navigate to="/ghana/trackers" replace />} />
              <Route path="/automated-report-generation-system" element={<Navigate to="/setup/ohlgs-setup" replace />} />
              <Route path="/automated-report-generation-system" element={<Navigate to="/setup/dpat-indicator-setup" replace />} />
              <Route path="/profile" element={<Navigate to="/ghana/dashboard" replace />} />

              {/* Placeholder routes for new menu items */}
              <Route path="/dpat-assessment" element={<Navigate to="/ghana/dpat-assessment" replace />} />
              <Route path="/dpat-dashboard" element={<Navigate to="/ghana/dpat-dashboard" replace />} />
              <Route path="/dpat-petitions" element={<Navigate to="/ghana/dpat-petitions" replace />} />
              <Route path="/reports" element={<Navigate to="/ghana/reports" replace />} />
              <Route path="/settings" element={<Navigate to="/ghana/settings" replace />} />
              <Route path="/ohlgs-consolidated" element={<Navigate to="/ghana/ohlgs-consolidated" replace />} />

            </Route>


            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </LocationProvider>
    </BrowserRouter>
  );
};

export default Routes;
